/* Program Name: LoadingContext.js
 **  Description: a component that handles the state of the loading modal
 **
 ** Project    Date        Who  Comments
 ** --------  ----------  ---  ---------------------------------------------------
 ** IS200241  2022-05-31  STT  Initial program
 *********************************************************************************/

/**React imports */
import React, { useContext, createContext, useState } from 'react'

//Creates the LoadingContext using reacts context //DOCS: https://reactjs.org/docs/context.html
const LoadingContext = createContext()

//Creates the hook to access the state of the LoadingContext //DOCS: https://reactjs.org/docs/hooks-custom.html
export function useLoading() {
  return useContext(LoadingContext)
}

/**Constructor for the AlertProvider component */
//children > props that passes the components through it like a wrapper
export default function AlertProvider({ children }) {
  /*********************************************************************************************** */
  /**Local Variables */

  const [isLoading, setIsLoading] = useState(false)

  const [loadingMessage, setLoadingMessage] = useState(null)

  /*********************************************************************************************** */
  /**Local Functions */

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const updateLoadingMessage = (msg) => {
    setLoadingMessage(msg)
  }

  //value is the object that is passed into the Provider which allows anything in the value to be access
  //by the children of AlertProvider
  const value = {
    loadingMessage,
    isLoading,
    startLoading,
    stopLoading,
    updateLoadingMessage,
  }

  /*********************************************************************************************** */
  /**Rendering */

  return (
    <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
  )
}
